export const FACEBOOK_PAGE_SCOPES = [
  'pages_manage_metadata',
  'business_management',
  'pages_messaging',
  'pages_show_list',
  'pages_read_engagement',
  // Reklam sayfasi icin: tek girisle hem gelen kutusu hem reklam yonetimi.
  'ads_read',
  'ads_management',
  // Urun katalogu icin. Jeton bu kapsami tasimazsa Graph API katalog uclari
  // (#100) "This application has not been approved to use this api" doner.
  'catalog_management',
  // Icerik bolumu sayfaya gonderi paylasiyor.
  'pages_manage_posts',
];

export const INSTAGRAM_SCOPES = [
  'instagram_basic',
  'instagram_manage_messages',
];

// Kurulum bazli izin listesi: OMNUP_FB_KAPSAMLARI doluysa istenen
// izinler TAM OLARAK odur (Instagram kapsamlari da eklenmez, cunku
// o kurulumda Instagram ayri bir akisla baglaniyor). Yalnizca gelen
// kutusu yoneten musteride reklam/katalog/gonderi izni istenmemeli.
const yapilandirilmisKapsamlar = () => {
  const ham = window.globalConfig?.OMNUP_FB_KAPSAMLARI;
  if (!ham || typeof ham !== 'string') return null;

  const liste = [...new Set(ham.split(',').map(k => k.trim()).filter(Boolean))];
  return liste.length ? liste : null;
};

export const buildFacebookLoginScopes = ({
  includeInstagramScopes = false,
} = {}) => {
  const ozel = yapilandirilmisKapsamlar();
  if (ozel) return ozel.join(',');

  const scopes = [...FACEBOOK_PAGE_SCOPES];
  if (includeInstagramScopes) {
    scopes.push(...INSTAGRAM_SCOPES);
  }
  return scopes.join(',');
};
